import { accentColorPropDef } from '@radix-ui/themes/props';
import { semanticColorValues } from '../../utils/semantic-color.js';
const sizeValues = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const iconColorValues = [...accentColorPropDef.color.values, ...semanticColorValues];
const iconPropDefs = {
    label: { type: 'string', required: true },
    fill: { type: 'string', default: 'currentColor' },
    icon: { type: 'IconLookup', required: true },
    size: {
        type: 'enum',
        className: 'rt-r-size',
        values: sizeValues,
        default: '2',
        responsive: true,
    },
    color: {
        ...accentColorPropDef.color,
        values: iconColorValues,
    },
};
export { iconPropDefs };
//# sourceMappingURL=icon.props.js.map